var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.privacyPolicyUrl)?_c('div',{staticClass:"privacy"},[_c('h3',[_vm._v(_vm._s(_vm.t('privacy', 'Privacy policy')))]),_vm._v(" "),_c('a',{staticClass:"privacy__link",attrs:{"target":"_blank","rel":"noreferrer noopener","href":_vm.privacyPolicyUrl}},[_vm._v("\n\t\t"+_vm._s(_vm.t('privacy', 'Read the privacy policy ↗'))+"\n\t")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }